
export class EntEntityTypes {
  id: number | null = null;
  alias: string | null = null;
  code: string | null = null;
  nameKy: string | null = null;
  nameRu: string | null = null;
  shortNameKy: string | null = null;
  shortNameRu: string | null = null;
} 